/* Sticky mobile buy bar (checklist item 40).

   This file only decides WHEN the bar is on screen. It deliberately does not
   touch price, variant id or availability: the bar's markup lives inside the
   same <form> as the main Add to bag button, so there is exactly one variant
   input on the page and nothing to keep in sync. assets/wn.js already writes
   every [data-wn-price] and [data-wn-atc] inside the product, which now
   includes the two in here. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-wn-buybar]');
  if (!bar) return;

  /* The real, in-page Add to bag button — the thing whose disappearance the
     bar is standing in for. */
  var anchor = document.querySelector('[data-wn-atc]:not(.wn-buybar__btn)');
  if (!anchor) return;
  if (!('IntersectionObserver' in window)) return;

  /* Reserve the bar's height up front rather than when it appears. Adding
     padding at reveal time would shift the page mid-scroll. The CSS scopes
     this to the widths the bar can actually show at, so no resize listener
     is needed. */
  document.documentElement.classList.add('wn-has-buybar');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      /* Show it only once the buy box has scrolled UP and off the top — not
         while it is still below the fold on first paint, which is also
         "not intersecting". */
      var stillBelow = en.boundingClientRect.top > 0;
      var show = !en.isIntersecting && !stillBelow;
      if (show) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    });
  }, { threshold: 0 });

  io.observe(anchor);
})();
